<div class="header">
  <div class="title">{{ title }}</div>
  <img
    src="assets/images/dashboards-icons/info.svg"
    class="tooltip"
    [matTooltip]="tooltip"
    matTooltipPosition="above"
    matTooltipClass="tooltip-container"
    alt="info"
  />
  <div class="spacer"></div>
  <ng-container *ngTemplateOutlet="headerExtraContent"></ng-container>
</div>
<div class="content">
  <ng-content></ng-content>
</div>
